import { configureStore } from '@reduxjs/toolkit'
import reduxImmutableStateInvariant from 'redux-immutable-state-invariant'
import reduxThunk from 'redux-thunk'
import { createPromise } from 'redux-promise-middleware'
import createDebounce from 'redux-debounced'

import rootReducer, { staticReducers } from './index'

export const middleware = [reduxThunk, createPromise(), createDebounce()]

if (process.env.NODE_ENV !== 'production') {
  middleware.push(reduxImmutableStateInvariant())
}

const store = configureStore({
  reducer: staticReducers,
  middleware,
  preloadedState: {},
  devTools: process.env.NODE_ENV !== 'production',
})
store.asyncReducers = {}
store.injectAsyncReducers = (reducers = {}) => {
  const reducerEntries = Object.entries(reducers)
  let reducersChanged = false

  reducerEntries.forEach(([key, reducer]) => {
    if (Object.prototype.hasOwnProperty.call(staticReducers, key)) {
      throw new Error(`Cannot replace static reducer "${key}"`)
    }

    if (typeof reducer !== 'function') {
      throw new TypeError(`Reducer "${key}" must be a function`)
    }
  })

  reducerEntries.forEach(([key, reducer]) => {
    if (store.asyncReducers[key] !== reducer) {
      store.asyncReducers[key] = reducer
      reducersChanged = true
    }
  })

  if (reducersChanged) {
    store.replaceReducer(rootReducer(store.asyncReducers))
  }
}
store.injectAsyncReducer = (key, reducer) =>
  store.injectAsyncReducers({ [key]: reducer })

export default store
